const commonHeaders = {
  'Content-Type': 'application/json'
}

export default {
  namespaced: true,
  state() {
    return {}
  },
  actions: {
    checkActivated() {
      return new Promise((resolve, reject) => {
        let url = `/api/v2/checkout/is-activated`;
        if (!!localStorage.getItem('access_token')) {
          commonHeaders.Authorization = `Bearer ${localStorage.getItem('access_token')}`
        }
        axios({
          url,
          method: 'get',
          headers: commonHeaders
        }).then(result => {
          resolve(result)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
    handle(context, data) {
      return new Promise((resolve, reject) => {
        let url = `${data.path}/v2/checkout`;
        if (!!localStorage.getItem('access_token')) {
          commonHeaders.Authorization = `Bearer ${localStorage.getItem('access_token')}`
        }
        axios({
          url,
          method: 'POST',
          data: data,
          headers: commonHeaders
        }).then(result => {
          resolve(result)
        }).catch(error => {
          console.log(error)
          reject(error)
        })
      })
    },
  },
  mutations: {},
  getters: {},
}
